// src/core/Components/ScrollToTop.tsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
export default function ScrollToTop() {
    const { pathname, hash } = useLocation();
    useEffect(() => {
        // If there's a hash (section ID), let the browser handle scrolling to that element
        if (hash) {
            // Small delay to ensure the element is rendered
            setTimeout(() => {
                const element = document.getElementById(hash.substring(1));
                if (element) {
                    element.scrollIntoView({ behavior: "smooth" });
                }
            }, 0);
        }
        else {
            // Only scroll to top if there's no hash
            window.scrollTo(0, 0);
        }
    }, [pathname, hash]);
    return null; // This component doesn't render anything
}
